import { MutationHookOptions, useMutation } from "@apollo/client";

// Apollo
import mutationGQL from "../../../mutation/catalog/createBid.graphql";
import {
  CreateBidMutation,
  CreateBidMutationVariables,
} from "@whoppah/apollo/schema";

/**
 * Hook for creating a bid as a buyer.
 * Note: Buyers always create bids, while sellers create counter bids.
 * @param options - Hook typing options.
 * @returns Mutation tuple, with executable calls.
 */
export const useCreateBid = (
  options?: MutationHookOptions<CreateBidMutation, CreateBidMutationVariables>
) => {
  return useMutation(mutationGQL, options);
};
